import { createFileRoute } from '@tanstack/react-router';

import { routeMetadata } from '@/app/lib/tanstack-router';
import { AuthorizedUsersPage } from '@/settings/pages/authorized-users';

export const Route = createFileRoute('/settings/_layout/authorized-users/')({
  head: () => ({
    meta: routeMetadata('Authorized Users')
  }),
  component: AuthorizedUsersRoute,
  staticData: {
    headerSection: null
  }
});

function AuthorizedUsersRoute() {
  return <AuthorizedUsersPage/>;
}
